export const ServiceWorkerModule = () => {
    const swListener = () => {
        navigator.serviceWorker.register('./sw.js').then(() => {
            window.removeEventListener('load', swListener);
        });
    };

    window.addEventListener('load', swListener);
    /*
    let refreshing;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        window.location.reload();
        refreshing = true;
    });
    */
};

export default ServiceWorkerModule;
